import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getAlertasProperty } from "./services";

const initialState: any = {
  status: "loading",
  data: {
    ocorrencias30d: 0,
    ocorrencias90d: 0,
    tratadas30d: 0,
    tratadas90d: 0,
    paraTratamento: 0,
    quantidadeLojas: 0,
    importanciaSegurada: 0,
    importanciaSeguradaRegional: 0,
    importanciaSeguradaLoja: 0,
    quantidadeClientes: 0,
    mttaMinutos: 0,
    mttrMinutos: 0,
  },
};

export const actionGetAlertasProperty = createAsyncThunk(
  "GET_ALERTAS_PROPERTY",
  async (params: {
    idLoja: number;
    idCliente: number;
    idRegional?: number;
    apiKey?: string | null;
  }) => {
    return await getAlertasProperty(
      params.idLoja,
      params.idCliente,
      params.idRegional || 0,
      params.apiKey || "",
    );
  },
);
const sliceGetAlertasProperty = createSlice({
  name: "GET_ALERTAS_PROPERTY",
  initialState,
  reducers: {
    actionResetGetAlertasProperty: (state) => {
      state.status = "loading";
      state.data = initialState.data;
    },
    updateAlertasPropertyData: (state, action) => {
      state.status = "success";
      state.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(actionGetAlertasProperty.pending, (state) => {
        state.status = "loading";
      })
      .addCase(actionGetAlertasProperty.fulfilled, (state, { payload }) => {
        state.status = "success";
        state.data = payload;
      })
      .addCase(actionGetAlertasProperty.rejected, (state) => {
        state.status = "error";
      });
  },
});

export default sliceGetAlertasProperty.reducer;
export const { actionResetGetAlertasProperty, updateAlertasPropertyData } =
  sliceGetAlertasProperty.actions;
